import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const AnnouncementsImage = props => (
    <SvgIcon {...props}>
        <path
            d="M14.744 12.843l-1.41 3.155H9.953l1.609-3.565a.5.5 0 01.456-.294h2.27a.5.5 0 01.457.704zm-8.85-10.93a.282.282 0 01.278.008l.017.01 5.618 3.957h3.088c.393.007.766.094 1.105.245v5.235c-.336.15-.707.237-1.096.245h-3.096l-5.62 3.956-.018.012a.283.283 0 01-.276.008.286.286 0 01-.152-.235V2.148a.286.286 0 01.152-.235zM3.432 12.177a.286.286 0 01.388.103.28.28 0 01-.089.377l-.015.009-1.971 1.129a.284.284 0 01-.389-.103.28.28 0 01.09-.377l.014-.009 1.972-1.13zm-.89-3.709a.282.282 0 01.016.564H.282a.282.282 0 01-.016-.563h2.276zM1.355 3.715a.286.286 0 01.373-.111l.016.008 1.971 1.13a.281.281 0 01-.142.526.284.284 0 01-.123-.027l-.02-.01L1.46 4.1a.281.281 0 01-.104-.386z"
            stroke="none"
            fillRule="nonzero"
        />
    </SvgIcon>
);

export default AnnouncementsImage;
